import styled from 'styled-components';

import CalendarToolbar from './CalendarToolbar';

const StyledCalendarToolbar = styled(CalendarToolbar)`
    height: 3rem;
    position: absolute;
    top: 2rem;
    width: 100%;

    .datepicker-btn {
        cursor: pointer;
        position: absolute;
        z-index: 500;
        background-color: ${(props) => props.theme.colours.primary};
        border: 0.1rem solid ${(props) => props.theme.colours.primary};
        border-radius: ${(props) => props.theme.corners.full}px;
        color: ${(props) => props.theme.colours.white};
        height: 3rem;
        min-width: 0;
        padding: 0;
        right: 2rem;
        width: 3rem;

        &:first-child {
            left: 2rem;
        }

        &:disabled {
            border: 0.1rem solid #919195;
            background-color: #919195;
            cursor: not-allowed;
            opacity: 0.2;
        }
    }
`;

export default StyledCalendarToolbar;
